import React from "react";
import styled from "styled-components";
import AppLink from "components/common/style/link/AppLink";
import UnitSearchList from "components/common/dl_unit/UnitSearchList/UnitSearchList";
import UnitFileFields from "components/common/dl_unit/edit/UnitFileFields";

const UnitEditList: React.FC = () => {
  return (
    <Div>
      <div>
        <UnitFileFields />
      </div>
      <div>
        <NewItem>
          <AppLink to="/admin-dashboard/dl-unit-new">novo</AppLink>
        </NewItem>

        <UnitSearchList editMode={true} />
      </div>
    </Div>
  );
};

export default UnitEditList;

const NewItem = styled.div`
  margin-top: 0;
`;

const Div = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
